import { Col, Inline, MatchMedia, Row, SecondaryNavigation } from '@george-labs.com/design-system';
import type { FC, ReactNode } from 'react';

import { isFeatureEnabled } from '@luna/gatekeeper';
import { t } from '@luna/i18n';

import type { NavigationProps } from './LayoutProps';
import styles from './MainLayout.module.scss';

type Props = NavigationProps & { className?: string } & {
    sideMenuProductInfo?: ReactNode;
    children: ReactNode;
};

export const LayoutWithSideMenu: FC<Props> = ({
    selectedItem,
    navigationItems,
    className = styles['side-menu-sticky-position'],
    children,
    sideMenuProductInfo,
}) => {
    const isExtendedGridEnabled = isFeatureEnabled((config) => config.bsExtendedGrid);
    if (!isExtendedGridEnabled) {
        return (
            <Row>
                <Col lg={3}>
                    <MatchMedia min={MatchMedia.TIER.LG}>
                        <Inline className={`${className} sticky-top`}>
                            {sideMenuProductInfo}
                            <SecondaryNavigation
                                items={navigationItems}
                                id="side-menu"
                                data-cy="side-menu"
                                selectedItem={selectedItem}
                                showIcons={navigationItems.some(({ icon }) => Boolean(icon))}
                                aria-label={t('main.sideMenu.navigationA11yLabel')}
                            />
                        </Inline>
                        <div
                            id="anchor-nav"
                            className={`${styles['anchor-navigation']} ml-auto mr-1`}
                        />
                    </MatchMedia>
                </Col>
                <Col lg={9}>
                    <main>{children}</main>
                </Col>
            </Row>
        );
    }

    return (
        <Row>
            <MatchMedia min={MatchMedia.TIER.LG}>
                {({ isMatching }) => {
                    if (isMatching) {
                        return (
                            <>
                                <Col lg={3} xl="auto" className={`${styles.sideMenu} d-print-none`}>
                                    <Inline className={`${className} sticky-top`}>
                                        {sideMenuProductInfo}
                                        <SecondaryNavigation
                                            items={navigationItems}
                                            id="side-menu"
                                            data-cy="side-menu"
                                            selectedItem={selectedItem}
                                            showIcons={navigationItems.some(({ icon }) =>
                                                Boolean(icon),
                                            )}
                                            aria-label={t('main.sideMenu.navigationA11yLabel')}
                                        />
                                    </Inline>
                                    <div
                                        id="anchor-nav"
                                        className={`${styles['anchor-navigation']} ml-auto mr-1`}
                                    />
                                </Col>
                                <Col xs={null} className={styles.content}>
                                    <main>{children}</main>
                                </Col>
                            </>
                        );
                    }

                    return (
                        <Col xs={12} className={styles.content}>
                            <main>{children}</main>
                        </Col>
                    );
                }}
            </MatchMedia>
        </Row>
    );
};
